import React from "react";

export default class DpcLinkUtiliMinisiti extends React.Component {
    render() {
        if (Array.isArray(this.props.linkUtili) && this.props.linkUtili.length > 0)
            return (
                <section className="btn-block-uppercase-wrapper">
                    <h2>{this.props.titoloSezione}</h2>
                    
                        <div className="row mb-3">
                            {
                                this.props.linkUtili.map(row =>
                                    row &&
                                    <div className="col-md-3">
                                        <a href={row.slug} className={"btn btn-primary"} title={row.title} target={row.titleLinkEsterno ? '_blank':'_self'} rel="noopener noreferrer"
                                           role="button">
                                            {row.title}
                                        </a>
                                    </div>
                                )
                            }
                        </div>
                </section>
            );
        return ("");
    }
}
